module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8367039032cfd3682ce830aa38dd62ba.png";